import {requirePermission} from '@/modules/auth/permissions'
import {ConsumableForm} from '@/modules/products/consumables/components'
import {NewConsumablePageSearchSchema} from '@/modules/products/consumables/schemas'
import {NewResourceFormContainer} from '@cypro/ui/components/ui/new-resource-form-container'
import {NewResourceFormHeader} from '@cypro/ui/components/ui/new-resource-form-header'
import {createFileRoute} from '@tanstack/react-router'
import {useTranslate} from '@tolgee/react'

export const Route = createFileRoute('/configuration/products/consumables/new')({
  beforeLoad: requirePermission('catalogue.manage'),
  component: NewConsumablePage,
  validateSearch: NewConsumablePageSearchSchema,
})

function NewConsumablePage() {
  const {t} = useTranslate('consumables')
  const {consumableId} = Route.useSearch()

  return (
    <NewResourceFormContainer>
      <NewResourceFormHeader
        title={consumableId ? t('edit_consumable_title') : t('new_consumable_title')}
        description={t('new_consumable_description')}
      />

      <ConsumableForm consumableId={consumableId} />
    </NewResourceFormContainer>
  )
}
